export default "__VITE_ASSET__ba1f07a2__"